module.exports = __webpack_public_path__ + "img/9_fineTeam_pp.d1a37f18.png";